// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"439":"c6553c87","537":"75f3734e"}[chunkId] + ".js";
};